import React from 'react';
import { WebsiteDesignProps } from './types';
import { ArrowRight, Cloud, Circle, ThermometerSun } from 'lucide-react';
import { Button } from "@/components/ui/button";

const NordicMinimal: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Oslo International";

    return (
        <div className="bg-white text-[#333] min-h-screen font-sans">
             <nav className="flex justify-between items-center p-8 md:p-12">
                 <div className="font-bold text-lg tracking-tight">{schoolName}.</div>
                 <div className="hidden md:flex gap-12 text-sm font-medium text-gray-500">
                     <a href="#" className="hover:text-black">School</a>
                     <a href="#" className="hover:text-black">Studies</a>
                     <a href="#" className="hover:text-black">Life</a>
                     <a href="#" className="hover:text-black">Apply</a>
                 </div>
                 <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center cursor-pointer hover:bg-black hover:text-white transition-colors">
                     <ArrowRight size={16} />
                 </div>
             </nav>

             <main className="container mx-auto px-8 md:px-12">
                 <section className="py-20 md:py-32">
                     <h1 className="text-6xl md:text-8xl font-light tracking-tighter mb-16 leading-none">
                         Simplicity <br/>
                         is the ultimate <br/>
                         sophistication.
                     </h1>
                     
                     <div className="flex flex-col md:flex-row gap-8 items-start">
                         <div className="flex-1">
                             <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2069&auto=format&fit=crop" className="w-full h-[600px] object-cover grayscale-[20%] rounded-sm" alt="Minimal Interior" />
                         </div>
                         <div className="w-full md:w-1/3 pt-12 space-y-12">
                             <div>
                                 <span className="text-xs font-bold uppercase tracking-widest text-gray-400 block mb-2">Philosophy</span>
                                 <p className="text-xl leading-relaxed">
                                     We remove the clutter to focus on what matters: your child's growth, happiness, and understanding of the world.
                                 </p>
                             </div>
                             <div>
                                 <span className="text-xs font-bold uppercase tracking-widest text-gray-400 block mb-2">Method</span>
                                 <p className="text-xl leading-relaxed">
                                     Self-directed learning in open, light-filled spaces designed for collaboration and deep thought.
                                 </p>
                             </div>
                             <div className="border-t border-gray-100 pt-8">
                                 <Button variant="ghost" className="pl-0 hover:bg-transparent hover:ml-2 transition-all text-lg">
                                     Read the manifesto <ArrowRight className="ml-2 w-5 h-5" />
                                 </Button>
                             </div>
                         </div>
                     </div>
                 </section>

                 <section className="py-24 border-t border-gray-100">
                     <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                         {[
                             { icon: Cloud, label: "Air Quality", val: "99%" },
                             { icon: ThermometerSun, label: "Natural Light", val: "High" },
                             { icon: Circle, label: "Student Ratio", val: "1:12" },
                             { icon: ArrowRight, label: "Graduates", val: "100%" },
                         ].map((item, i) => (
                             <div key={i} className="bg-gray-50 p-8 rounded-sm text-center hover:bg-gray-100 transition-colors">
                                 <item.icon className="mx-auto mb-4 text-gray-400" size={24} />
                                 <div className="text-3xl font-light mb-1">{item.val}</div>
                                 <div className="text-xs uppercase tracking-widest text-gray-400">{item.label}</div>
                             </div>
                         ))}
                     </div>
                 </section>
             </main>
        </div>
    );
};

export default NordicMinimal;
